import type { ExplicitAddress } from '@cronos-app/sdk';
import { create } from 'zustand';

import { useBondingTradeForm } from './components/BondingTradeForm/useBondingTradeForm';

interface BondingTradeDialogStore {
  isOpen: boolean;
  bondingTokenAddress: ExplicitAddress;
  closable: boolean;
  open: (options: { bondingTokenAddress: ExplicitAddress }) => void;
  close: () => void;
}

export const useBondingTradeDialog = create<BondingTradeDialogStore>((set) => ({
  isOpen: false,
  view: 'default',
  bondingTokenAddress: '',
  closable: true,
  close: () => {
    set({
      isOpen: false,
    });
  },
  open: ({ bondingTokenAddress }) => {
    // reset store
    useBondingTradeDialog.setState(
      useBondingTradeDialog.getInitialState(),
      true,
    );
    useBondingTradeForm.setState(useBondingTradeForm.getInitialState(), true);
    set({
      isOpen: true,
      bondingTokenAddress,
    });
  },
}));
